// import { HasPermission } from '../../Helper/Permisstions/Permisstions';

const fassetsMenu = [
  {
    System: 'ASSETS',
    isActive: false,
    menu: [
      { is_header: true, title: 'نظام إدارة الأصـول', isActive: true }, // عنوان إدارة الأصول

    
      {
        path: '/ASSETS/HomePage',
        icon: 'fas fa-home',
        title: 'HomePage',
        isActive: true
      },
      { is_header: true, title: 'Settings', isActive: true },

      {
        path: '/ASSETS/FaCategories',
        icon: 'fas fa-tags', // أيقونة فئات الأصول
        title: 'فئات الأصول',
        isActive: true
      },

      {
        path: '/ASSETS/FaAssets',
        icon: 'fas fa-boxes', // الأصول
        title: 'الأصول',
        isActive: true
      },
      { is_header: true, title: 'Operations', isActive: true },

      {
        path: '/ASSETS/FaDepreciation',
        icon: 'fas fa-percentage', // إهلاك أصل
        title: 'الإهلاكــات',
        isActive: true
      },
      {
        path: '/ASSETS/FaRevaluation',
        icon: 'fas fa-chart-line', // إعادة تقييم الأصول
        title: 'إعادة تقييم الأصول',
        isActive: true
      },
      {
        path: '/ASSETS/FaRetirement',
        icon: 'fas fa-trash-alt', // إستبعاد الأصول
        title: 'إستبعاد الأصول',
        isActive: true
      },
      {
        path: '/ASSETS/FaAdjustCost',
        icon: 'fas fa-edit', // تعديل تكلفة الأصل
        title: 'تعديل تكلفة الأصل',
        isActive: true
      },
      {
        path: '/ASSETS/FaTransfer',
        icon: 'fas fa-exchange-alt', // نقل الأصول
        title: 'نقل الأصول',
        isActive: true
      },

      { is_header: true, title: 'الإدارة المالية', isActive: true },
      {
        path: '/ASSETS/CreateAccount',
        title: 'ترحيل عمليـات الأصـول',
        icon: 'fas fa-share-square',
        isActive: true
      },

      {
        path: '/ASSETS/AccountingPeriod',
        title: 'AccountingPeriod',
        icon: 'fas fa-calendar-alt',
        isActive: true
      },

      { is_header: true, title: 'Reports', isActive: true },
      {
        path: '/ASSETS/Reports',
        icon: 'fas fa-chart-line',
        title: 'Reports',
        isActive: true
      },
      {
        path: '/ASSETS/Dashboards',
        icon: 'fas fa-th-large',
        title: 'Dashboard',
        isActive: true
      }
      // { is_header: true, title: 'نظام إدارة الأصـول', isActive: true },
      // {
      //   path: 'dashboard',
      //   icon: 'fas fa-home',
      //   title: 'HomePage',
      // },

      // {
      //   path: 'Finance/FA/',
      //   icon: 'bi bi-aspect-ratio-fill',
      //   title: 'الأصول',
      //   children: [
      //     {
      //       path: 'Finance/FA/FaCategories',
      //       title: 'فئات الأصول',
      //       isActive: true,
      //     },
      //     {
      //       path: 'Finance/FA/FaAssets',
      //       title: 'الأصول',
      //       isActive: true,
      //     },
      //   ],
      // },
    ]
  }
];

export default fassetsMenu;
